<div fxLayout="row" style="margin-bottom: 20px;">
  <div fxLayout="column" fxLayoutAlign="start" fxFlex="90">
    <h2 style="margin: 0; padding: 0;">ย้ายสายงาน</h2>
  </div>
  <div fxLayout="column" fxFlex="10">
    <button mat-raised-button color="primary" (click)="onClose()">
      <span>ปิด</span>
    </button>
  </div>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
  <div fxLayout="column" fxLayoutAlign="start" fxFlex="33">
    <app-dropdown-company [(ngModel)]="companyId" (ngModelChange)="onGetBranch()"></app-dropdown-company>
  </div>
  <div fxLayout="column" fxLayoutAlign="start" fxFlex="33" class="pl-4">
    <mat-form-field appearance="outline">
      <mat-label>สาขา</mat-label>
      <mat-select [(ngModel)]="branchId" (ngModelChange)="onGetTeam()">
        <mat-option *ngFor="let branch of branchs" [value]="branch.id">
          {{ branch.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="column" fxLayoutAlign="start" fxFlex="33" class="pl-4">
    <mat-form-field appearance="outline">
      <mat-label>สายงาน</mat-label>
      <mat-select [(ngModel)]="teamId" (ngModelChange)="onGetTeamById()">
        <mat-option *ngFor="let team of teams" [value]="team.id">
          {{ team.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="tree" *ngIf="salesStructureDetails.length">
  <app-tree mode="edit"
            action="transfer"
            [data]="salesStructureDetails"
            [companyId]="companyId"
            [branchId]="branchId"
            [team]="data.team"
            (onHandler)="onSetSalesStructureTeam($event)"></app-tree>
</div>
